export const CREATE = "CREATE"
export const UPDATE = "UPDATE"
export const DELETE = "DELETE"
export const LIKE = "LIKE"
export const FETCH_ALL = "FETCH_ALL"
export const FETCH_BY_SEARCH = "FETCH_BY_SEARCH"

export const LOGOUT = "LOGOUT"
export const AUTH = "AUTH"
